import React, { useState, useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { translate, formatData, isNullOrEmpty, downloadFile } from '../../../../utils/util';
import { Input, BackButton, Title, Button, ListPaginationNew, Select } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { ENUMS } from '../../../../utils/constants';

const ReprocessReportList = (props) => {
    const [data, setData] = useState([]);
    const [instanceM, setInstanceM] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [filterSearch, setFilterSearch] = useState({
        entrance: null,
        errorMessage: null,
        dateStart: null,
        dateEnd: null,
        success: false
    });

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        setData([]);
        setTotalPages(0);
        setCurrentPage(0);
        return () => {
            setData([]);
        }
        // eslint-disable-next-line
    }, []);

    const onSearch = (refreshing) => {
        props.getTransmissions({
            ...filterSearch,
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        }, (c) => {
            let list = [];
            Object.assign(list, data);
            refreshing ? list = c.items : list.push(...c.items)
            setData(list);
            setTotalPages(c.totalPages);
            instanceM[1].close();
        });
    }

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const onClick = () => {
        setData([])
        setCurrentPage(0);
        onSearch(true)
    }

    const downloadReport = () => {
        props.getReport(filterSearch, (data) => {
            downloadFile(data, `FileLog${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('change-location:menu.reprocessreport')} />
            <div className="container-fluid" >
                <div className="container">
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            defaultValue={filterSearch.dateStart}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="dateStart"
                                            name="dateStart"
                                            onChange={onChange}
                                            required={!isNullOrEmpty(filterSearch.dateEnd)}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filterSearch.dateEnd}
                                            type="date"
                                            label={translate('change-location:endDate')}
                                            id="dateEnd"
                                            name="dateEnd"
                                            onChange={onChange}
                                            required={!isNullOrEmpty(filterSearch.dateStart)}
                                        />
                                    </div>
                                    <div className="input-field padding col s6" style={{ paddingTop: '11px' }}>
                                        <Input
                                            id="entrance"
                                            name="entrance"
                                            placeholder={translate('cim', 'physical-confirmation')}
                                            type="text"
                                            maxLength={10}
                                            defaultValue={filterSearch.entrance}
                                            onChange={onChange}
                                            onBlur={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5" style={{ marginBottom: '0px' }}>
                                        <Select
                                            id="success"
                                            name="success"
                                            display="description"
                                            defaultValue={filterSearch.success}
                                            data={[{ id: true, text: translate('physical-confirmation:success'), }, { id: false, text: translate('physical-confirmation:fail') }]}
                                            change={onChange}
                                            placeHolder={`Status - ${translate('general:choose-one-option')}`}
                                        />
                                    </div>
                                    <div className="row" style={{ marginTop: '10px', marginBottom: '10px' }}>
                                        <Button full="true" onClick={() => onClick()} text={translate('search', 'general')} />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    {data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                <div id="list">
                    <ListPaginationNew
                        page={totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item, index) => {
                            return (
                                <div
                                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                                    key={`oi-${index}`}
                                >
                                    <span className="sixth-text-color" style={{ display: 'block' }}>{item.partNumber}</span>
                                    <b className="sixth-text-color" style={{ display: 'block' }}>{item.cim} - {item.location}</b>
                                    <i className="sixth-text-color" style={{ display: 'block' }}>{item.message}</i>
                                    <span className="sixth-text-color" style={{ display: 'block' }}>{item.fileName?.fileName ?? ""}</span>
                                    <span className="sixth-text-color" style={{ display: 'block' }}>{item.createdByDesc} | {item.updatedByDesc}</span>
                                    <span className="sixth-text-color" style={{ display: 'block' }}>{formatData(item.createdOn)} | {formatData(item.updatedOn)}</span>
                                    {!isNullOrEmpty(item.cimQuantity) && item.cimQuantity > 0 &&
                                        <span className="second-text-color"  >
                                            <b className="sixth-text-color">{translate('cim-quantity', 'change-location')}: </b> {item.cimQuantity || '0'}
                                        </span>
                                    }
                                </div>
                            );
                        })}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, callback) => {
            dispatch(ChangeLocationService.getTransmissionsReprocess(filter, callback));
        },
        getReport: (filter, callback) => {
            dispatch(ChangeLocationService.getReportTransmission(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessReportList)));

